import request from '@/utils/request'

// 获取生产工单数量
export function getWorkorderLargeScreenCount(data) {
  return request({
    url: '/mobile/pro/workorder/largeScreenCount',
    method: 'get',
    params: data
  })
}
// 获取生产工单进度
export function getWorkorderLargeScreenList(data) {
  return request({
    url: '/mobile/pro/workorder/listForFront',
    method: 'get',
    params: data
  })
}

// 运行情况
export function getWorkorderAllCompleteCount(data) {
  return request({
    url: '/mobile/pro/workorder/allCompleteCount',
    method: 'get',
    params: data
  })
}
// 运行情况-运行天数
export function getWorkorderAllCompleteDay(data) {
  return request({
    url: '/mobile/pro/workorder/safeOperationDays',
    method: 'get',
    params: data
  })
}
// 运行情况3
export function getUserCount(data) {
  return request({
    url: '/mobile/pro/workorder/userCount',
    method: 'get',
    params: data
  })
}
// 仓库管理
export function getStockCount(data) {
  return request({
    url: '/mobile/wm/wmstock/stockCount',
    method: 'get',
    params: data
  })
}
// 仓库管理2
export function getWarehouseStatisticsCount(data) {
  return request({
    url: '/mobile/wm/issueheader/warehouseStatisticsCount',
    method: 'get',
    params: data
  })
}
// 仓库管理3
export function getReturnRate(data) {
  return request({
    url: '/mobile/pro/workorder/returnRate',
    method: 'get',
    params: data
  })
}
// 质量管理
export function getQualityCount(data) {
  return request({
    url: '/mobile/qc/oqc/qualityCount',
    method: 'get',
    params: data
  })
}
// 质量管理2
export function getQualityRate(data) {
  return request({
    url: '/mobile/qc/oqc/qualityRate',
    method: 'get',
    params: data
  })
}
// 质量管理3
export function getQualitySingleRate(data) {
  return request({
    url: '/mobile/qc/oqc/qualitySingleRate',
    method: 'get',
    params: data
  })
}
// 设备管理
export function getDeviceStatusCount(data) {
  return request({
    url: '/mobile/dv/machinery/deviceStatusCount',
    method: 'get',
    params: data
  })
}
// 设备管理2
export function getOrderStatusCount(data) {
  return request({
    url: '/mobile/dv/checkplan/orderStatusCount',
    method: 'get',
    params: data
  })
}
// 设备管理3
export function getOperatingRate(data) {
  return request({
    url: '/mobile/dv/machinery/operatingRate',
    method: 'get',
    params: data
  })
}
// 工艺流程
export function getProcesses(data) {
  return request({
    url: '/mobile/pro/protask/processes',
    method: 'get',
    params: data
  })
}
// 人员管理
export function getFeedbackList(data) {
  return request({
    url: '/mobile/pro/feedback/listForFront',
    method: 'get',
    params: data
  })
}
// 监控管理
export function listCamera() {
  return request({
    url: '/mes/sys/camera/list',
    method: 'get',
  })
}
// 每日统计
export function getRecordRate(data) {
  return request({
    url: '/mobile/qc/oqc/recordRate',
    method: 'get',
    params: data
  })
}
export function getTaskRate(data) {
  return request({
    url: '/mobile/qc/oqc/taskRate',
    method: 'get',
    params: data
  })
}
